export default __webpack_public_path__ + "static/media/vanxuong.39ec21a8.png";